import React from "react";
import { connect } from "react-redux";
import { authenticate } from "MODULES/session/actions";
import api from "APP_ROOT/api";
import { withPolling } from "MODULES/shared/decorators";

function AwaitingMfa() {
  return (
    <h1 className="text-center margin-top-none">
      Please Authenticate with your MFA Provider
    </h1>
  );
}

AwaitingMfa.propTypes = {};

export default connect(
  () => ({ refreshRate: 5000 }),
  (dispatch, ownProps) => ({
    refresh: () =>
      api.session
        .verifyPush({
          email: ownProps.email,
          password: ownProps.password,
          pushIds: ownProps.pushIds
        })
        .then(({ data }) => {
          dispatch(
            authenticate({
              password: ownProps.password,
              email: ownProps.email,
              push_id: data.push_id
            })
          );
        })
        .catch(() => {})
  })
)(withPolling(AwaitingMfa));



// WEBPACK FOOTER //
// ./app/modules/session/components/AwaitingMfa/AwaitingMfa.jsx